module.exports = __webpack_public_path__ + "@/assets/img/cursoIA-pricinpalBanner.b9f69a3b.png";